"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogWrapper = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Common_1 = require("../FormFields/Common");
const EditComponentButtonWeb_1 = __importDefault(require("./EditComponentButtonWeb"));
const utils_1 = require("../../utils");
const theme_1 = require("../../styles/theme");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const DialogWrapper = props => {
    const classes = (0, Common_1.useStyles)();
    const { type, value, renderComponent, position, renderValue, renderHeader, readOnly, clearValue, renderMiddleValue, label, translateFunction = text => text } = props, moreProps = __rest(props, ["type", "value", "renderComponent", "position", "renderValue", "renderHeader", "readOnly", "clearValue", "renderMiddleValue", "label", "translateFunction"]);
    const dialogStyles = useDialogStyles(props);
    const [open, setOpen] = (0, react_1.useState)(false);
    const toggleModal = () => {
        setOpen(!open);
    };
    const isNotEmpty = Array.isArray(value) ? value.length > 0 : !!value;
    const DeleteIcon = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.IconButton, { "aria-label": "clear", onClick: clearValue, disabled: readOnly, className: dialogStyles.iconBtn },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faTrashCan, className: dialogStyles.deleteIcon }))));
    };
    return (react_1.default.createElement("div", { className: classes.formElementWrapper },
        react_1.default.createElement(core_1.Dialog, { open: open, classes: { paper: dialogStyles.dialogPaper } },
            react_1.default.createElement(core_1.DialogContent, { className: dialogStyles.dialogContent }, renderComponent && renderComponent(toggleModal))),
        renderHeader && renderHeader(),
        position === 'top' && isNotEmpty && (react_1.default.createElement("div", { className: dialogStyles.bodyRoot },
            renderValue && renderValue(),
            " ",
            renderMiddleValue && renderMiddleValue(),
            isNotEmpty && react_1.default.createElement(DeleteIcon, null))),
        position === 'bottom' && isNotEmpty && (react_1.default.createElement("div", { className: dialogStyles.bodyRoot },
            renderMiddleValue && renderMiddleValue(),
            isNotEmpty && react_1.default.createElement(DeleteIcon, null))),
        react_1.default.createElement(EditComponentButtonWeb_1.default, { readOnly: !!readOnly, type: type, mode: value ? 'edit' : 'add', onClick: toggleModal, label: label, translateFunction: translateFunction }),
        position === 'bottom' && renderValue && renderValue()));
};
exports.DialogWrapper = DialogWrapper;
const PADDING_SPACE = 11;
const DIALOG_VERTICAL_MARGIN = 16;
const useDialogStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    dialogPaper: {
        height: `calc(95vh - ${DIALOG_VERTICAL_MARGIN}px)`,
        maxHeight: '100%',
        width: '650px',
        maxWidth: '100%',
        padding: '6px 0px 6px 0px',
        [theme.breakpoints.down(utils_1.MOBILE_BREAKPOINT + 1)]: {
            height: '100%',
            width: '100%',
            margin: 0,
            maxHeight: `calc(100% - ${PADDING_SPACE}px)`,
            borderRadius: 0,
        },
        display: 'flex',
        flexDirection: 'column',
    },
    dialogContent: {
        flex: 1,
        overflowY: 'hidden',
        padding: 0,
        '&.MuiDialogContent-root:first-child': {
            paddingTop: 0,
        },
    },
    bodyRoot: {
        display: 'flex',
        paddingBottom: 10,
        alignItems: 'center',
        gap: 5,
    },
    deleteIcon: {
        width: 14,
        height: 15.077,
        flexShrink: 0,
        fill: theme_1.colors.dimGrey,
    },
    iconBtn: { padding: 5, backgroundColor: theme_1.colors.whiteSmoke },
}));
exports.default = exports.DialogWrapper;
//# sourceMappingURL=DialogWrapperWeb.js.map